module.exports = __webpack_public_path__ + "static/markbart-f997d7f9c219e12d1d17fee00467a146.jpg";